// Cross-form Validator
import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

// Validates if a cell phone is required for a driver. 
//  Requires the FormGroup's FormControl names for the driver to be:
//  1. sendSmsMonitoringUpdates is true
export const monitorValidationCodeRequiredValidator: ValidatorFn = (
    control: AbstractControl,
): ValidationErrors | null => {
    const sendSMS = control.get('enrolledInSms')?.value;
    const cellNumber = control.get('cellPhoneNumber')?.value;
    const validationCode = control.get('validationCode')?.value;
    let cellValid = false;
    let isValid = false;
    if (sendSMS === true) {
        cellValid = cellNumber?.length > 0;
    } 
    if (cellValid && validationCode) {
        isValid = validationCode.toString().length > 0;
    }

const hasRequiredError = isValid === false;
    return hasRequiredError
        ? { validationCodeRequired: true }
        : null;
};